import { useAuth } from "../context/AuthContext";
import { logout, plusCircle } from "../assets";

type HeaderProps = {
  handleAddButton?: () => void;
  handleAboutButton?: () => void;
  isAbout?: boolean;
  isFormOpen?: boolean;
};

const Header = ({
  handleAddButton,
  handleAboutButton,
  isAbout,
  isFormOpen,
}: HeaderProps) => {
  const { authUser, logOut } = useAuth();

  const handleLogout = async () => {
    await logOut();
  };

  return (
    <header className='flex' style={{ justifyContent: "space-between" }}>
      <h1>Cloudmark</h1>
      {authUser ? (
        <div className='header-buttons'>
          <button onClick={handleAddButton}>
            <img
              src={plusCircle}
              alt='plus'
              title='Add'
              style={{
                transition: "all 0.25s ease-in-out",
                transform: isFormOpen ? "rotate(-45deg)" : "none",
              }}
            />
          </button>
          <button onClick={handleLogout}>
            <img src={logout} alt='logout' title='Logout' />
          </button>
        </div>
      ) : (
        <button onClick={handleAboutButton}>
          {isAbout ? "Back" : "About"}
        </button>
      )}
    </header>
  );
};

export default Header;
